export const m = {
  platform_name: 'Developer Center',
  changeLangConfirm: 'Are you sure to switch the language?',
  confirmText: 'Confirm',
  cancel: 'Cancel ',
  commonTip: 'Prompt',
  cancelManual: 'Cancel Manual',
  application_development_scenario: 'Application development scenario',
  overview_of_open_capabilities: 'Overview of open capabilities',
  noun_interpretation: 'Noun interpretation',
  update_log: 'Update log',
  registered_developer_account: 'Registered developer account',
  create_docking_application: 'Create docking application',
  use_of_frontend_debugging_tools: 'Use of front-end debugging tools',
  quick_build_service: 'Quick build service',
  configuration_center: 'Configuration center',
  security_components: 'Security components',
  log_framework: 'Log framework',
  log_collection: 'Log collection',
  distributed_tasks: 'Distributed tasks',
  excel_import_and_export: 'Excel import and export',
  encryption_and_decryption_module: 'Encryption and decryption module',
  streaming_media: 'Streaming media',
  file_upload_component: 'File upload component',
  rich_text_component: 'Rich text component',
  online_text_display_component: 'Online text display component',
  front_end_permission_component: 'Front end permission component',
  behavior_collection_module: 'Behavior collection module',
  must_read_before_development: 'Must read before development',
  open_api_summary: 'Open API Summary',
  interface_debugging: 'Interface debugging',
  summary: 'Summary',
  unified_authentication: 'Unified authentication',
  single_sign_on: 'Single sign on',
  get_authorization_code: 'Get authorization code',
  obtaining_a_token: 'Obtaining a token',
  refresh_token: 'Refresh token',
  get_user_list: 'Get user list',
  getting_user_information_token: 'Getting user information(Token)',
  getting_user_information_userid: 'Getting user information(UserId)',
  user_name_duplicate_check: 'User name duplicate check',
  get_user_organization_information: 'Get user organization information',
  acquiring_institutions_according_to_id: 'Acquiring institutions according to ID',
  query_school_list: 'Query school list',
  query_school_id: 'Query School(ID)',
  query_term_list: 'Query term list',
  query_timetable_list: 'Query timetable List',
  query_class_list: 'Query class list',
  query_class_id: 'Query Class(ID)',
  query_teacher_list: 'Query teacher list',
  query_teacher_id: 'Query teacher(ID)',
  query_teaching_information_list: 'Query teaching information list',
  query_student_list: 'Query student list',
  query_student_id: 'Query student(ID)',
  query_parents_list: 'Query parents list',
  query_parent_id: 'Query parent(ID)',
  query_dictionary_type_list: 'Query dictionary type list',
  query_dictionary_information_list: 'Query dictionary information list',
  query_weekly_schedule__template_list: 'Query weekly schedule (template) list',
  query_daily_schedule_list: 'Query daily schedule list',
  query_teaching_building: 'Query teaching building',
  query_classroom: 'Query classroom',
  query_attendance_information: 'Query attendance information',
  storage_message: 'Storage message',
  number_of_unread_messages: 'Number of unread messages',
  view_message_list: 'View message list',
  view_session_list: 'View session list',
  view_session_messages: 'View session messages',
  update_to_read: 'Update to read',
  removal_message: 'Removal message',
  delete_the_session: 'Delete the session',
  query_unread_message: 'Query unread message',
  java_client_rapid_integration: 'Java client rapid integration',
  spring_cloud_client_rapid_integration: 'Spring Cloud client rapid integration',
  file_upload: 'File upload',
  file_download: 'File download',
  file_convert: 'file convert',
  get_a_list_of_questions: 'Get the list test question',
  get_details_of_questions: 'Get details of questions',
  translate: 'Translate',
  speech_recognition: 'Speech recognition',
  speech_synthesis: 'Speech synthesis',
  word_recognition: 'Character recognition',
  client_rapid_integration: 'Fast integration of client',
  obtaining_authorization: 'Obtaining authorization',
  update_authorization: 'Update authorization',
  authorization_recovery: 'Authorization revocation',
  apply_for_subscriptions: 'Apply for subscriptions',
  modify_subscriptions: 'Modify subscriptions',
  open_subscribe: 'Enable subscription',
  unsubscribe: 'Cancel subscription',
  query_subscription: 'Query subscription',
  query_text: 'Post Query',
  query_comment: 'Comments Query',
  query_log: 'Query Log',
  kafka_message: 'Kafka message',
  sdk_download: 'SDK download',
  error_code_specification: 'Error code specification',
  global_error_code: 'Global error code',
  interface_call_problem: 'Interface call problem',
  access_problem: 'Access problem',
  user_problem: 'User problem',
  business_problems: 'Business problems',
  default_title: 'Default Title',
  common_problem: 'Common problem',
  identity_check: 'Authentication',
  basic_data_api: 'Basic Data Api',
  curriculum_schedule: 'Curriculum schedule',
  attendance_interface: 'Attendance Interface',
  message_center: 'Message center',
  file_service: 'File service',
  question_service: 'Question service',
  ai_service: 'AI service',
  opinion_service: 'Public opinion service',
  instant_message: 'Instant message',
  error_code: 'Error code',
  service: 'Service',
  front_end_component: 'Front end component',
  dev_ready: 'Development preparation',
  quick_start: 'Quick start',
  frame: 'Framework',
  open_api: 'Open API',
  input_key: 'please input key',
  update_time: 'Update time',
  editor: 'Editor',
  upload_file: 'Upload File',
  save: 'Save',
  cancle: 'Cancle',
  support_file_type_info: 'Support file type：image ,office',
  introduce: 'Introduce',
  design: 'Design',
  integrate: 'Integrate',
  logout: 'Logout',
  login: 'Login',
  design_principles: 'Design principles',
  concise_and_clear: 'Concise And Clear',
  flexible_and_efficient: 'Flexible And Efficient',
  user_control: 'User Control',
  visual_norms: 'Visual Norms',
  layout: 'Layout',
  color: 'Color',
  font: 'Font',
  icon: 'Icon',
  button: 'Button',
  loginAccountPlaceHolder: 'Account, phone number or email',
  inputPwdTip: 'Enter your password',
  selectOrgTip: 'elect an organization',
  yzmPlaceHolder: 'Verification code',
  yzmEmptyTip: 'The verification code is required',
  changeAnother: 'Change',
  loginFailed: 'Login failed, please contact the administrator.',
  selectSuiteBroseTip: 'Please use IE9 or higher, Chrome, Firefox and other applicable browsers',
  loginNameRepeatTip: 'Repeated login name, please choose your own user name to log in',
  userStatusNotCorrectTip: 'This user isn\'t in normal status, please contact administrator',
  userNotExistTip: 'Login name does not exist.',
  loginPwdError: 'Password wrong.',
  loginNameInputTip: 'Enter a user name',
  checkCodeError: 'Verification code error',
  getCheckcodeError: 'Failed to obtain the verification code',
  xwqqlogin: 'WeChat or QQ login',
  operation: 'Operation Hub',
  addGoods: 'Add Goods',
  modifyGoods: 'Modify Goods',
  queryGoods: 'Query Goods',
  saveOrder: 'Save Order',
  cancelOrder: 'Cancel Order',
  queryOrder: 'Query Order',
  ssoFailed: 'Login failed.',
  payService: 'Payment service',
  howtoLogin: 'log in',
  howtoFindPwd: 'How do I log in?',
  xtbg: 'Cooperative office',
  xtsyxd: 'System Use Wizard',
  wjdc: 'questionnaire investigation',
  zymgnjs: 'Main page layout and function introduction',
  xtsz: 'System settings',
  dzgrzy: 'How to customize personal homepage',
  glbmyhxx: 'Management department and user information',
  kqgzsz: 'Attendance Rule Settings',
  lczx: 'Process Center',
  lcfqxj: 'Initiate creation',
  lcwddb: 'My To Do',
  jbgz: 'Handling and tracking',
  lscx: 'Historical query',
  xzbg: 'Administrative office',
  rw: 'task',
  grrwzy: 'Personal Tasks Home Page',
  rwxm: 'project',
  rwdt: 'dynamic',
  dcwj: 'questionnaire',
  cjwj: 'Create questionnaire',
  hswj: 'Take back the questionnaire',
  wjcx: 'Questionnaire Query&Delete',
  ckwjdt: 'Check the answers to the questionnaire',
  txwj: 'Fill in the questionnaire',
  kmwp: 'KM network disk (knowledge management)',
  kmgnjs: 'Km function introduction',
  kmqxqb: 'Differences in the permissions of different roles of km to use the network disk',
  kmdlfs: 'How to log in to the km network disk',
  kmsy: 'How to log in to the km network disk',
  kmgrwp: 'Personal online disk',
  kmggwp: 'Public network disk',
  znxxgg: 'In station messages and announcements',
  xxrk: 'entrance',
  xtxx: 'System messages',
  yhxx: 'User Message',
  xxgg: 'Notice',
  fbwj: 'Issue questionnaire',
  wjhswj: 'Collect the answer sheet',
  wjfxxz: 'Analysis&Download',
  tjfxxz: 'Statistics and analysis',
  ckxzdj: 'View the download answer sheet',
  wjfz: 'Questionnaire copy',
  wjsc: 'Questionnaire deletion',
  wjzx: 'Questionnaire Center',
  wjcjwj: 'Create questionnaire',
  wjsjwj: 'Design questionnaire',
  wjsz: 'Questionnaire Settings',
  wjwgsz: 'Appearance Settings',
  developer_platform: 'developer platform',
  BusinessAPP: 'business application',
  document_menu_management: 'Document menu management',
  zwwd: 'No document',
  cdlmsz: 'Menu Column Settings',
  menuName: 'Menu Name',
  superior: 'superior',
  selectTop: 'Select Superior',
  nothing: 'nothing',
  sortNum: 'sortNum',
  appType: 'appType',
  appTypeTeching: 'appTypeTeching',
  appTypeStudy: 'appTypeStudy',
  appTypeManage: 'appTypeManage',
  appTypeEvaluate: 'appTypeEvaluate',
  appTypeResearch: 'appTypeResearch',
  appTypeResource: 'appTypeResource',
  appTypeOther: 'appTypeOther',
  appTypeClass: 'appTypeClass',
  appTypeOtherTools: 'appTypeOtherTools',
  qsycdmc: 'Please enter the menu name',
  qsrxh: 'Please enter the serial number',
  bccg: 'Saving succeeded',
  add: 'newly added',
  kfjk: 'Open interface',
  common: 'common',
  ssjg: 'Search results',
  mycxdjl: 'No matching records found',
  twtymyapi: 'Tianwen Unified Portal Platform API',
  twzjk: 'Tianwen Component Library',
  yhtx: 'User avatar'
}



// WEBPACK FOOTER //
// ./src/lang/en.js